// assets/hide-cod-soldout.js
(function () {
  "use strict";

  function isSoldOut() {
    // Detecta "Agotado" en la página
    const t = (document.body && document.body.innerText ? document.body.innerText : "").toLowerCase();
    if (t.includes("agotado")) return true;

    // Detecta ATC deshabilitado (por si cambia el texto)
    const atc =
      document.querySelector('button[name="add"]') ||
      document.querySelector(".product-form__submit") ||
      document.querySelector('[data-add-to-cart]');
    if (atc && (atc.disabled || atc.getAttribute("aria-disabled") === "true")) return true;

    return false;
  }

  function hideCODButtons() {
    if (!isSoldOut()) return;

    // Zona típica donde están los botones de compra (en caso de tema Shrine)
    const scope =
      document.querySelector("product-form") ||
      document.querySelector(".product__info-container") ||
      document;

    // 1) Cualquier cosa de EasySell (clases suelen empezar con es-)
    scope.querySelectorAll('[class*="es-"], [id*="es-"], [class*="easysell"], [id*="easysell"]').forEach((el) => {
      // No toques el widget de "Avísame cuando vuelva" (Notify-me suele NO tener es-)
      // Ocultamos contenedores grandes/visibles
      const tag = (el.tagName || "").toLowerCase();
      if (tag === "script" || tag === "style") return;

      // Si contiene el subtítulo que me mostraste, seguro es COD
      if (el.classList && el.classList.contains("es-button-subtitle")) {
        const wrap = el.closest("button, a, div");
        if (wrap) wrap.style.display = "none";
      }
    });

    // 2) El botón rojo “vacío”: lo cazamos por estilo (background rojo) dentro del área de compra
    const candidates = scope.querySelectorAll("button, a, div");
    candidates.forEach((el) => {
      // Evitar esconder el botón negro de notify-me
      const txt = (el.innerText || "").toLowerCase();
      if (txt.includes("avísame") || txt.includes("avisame") || txt.includes("notify")) return;

      const cs = window.getComputedStyle(el);
      const bg = (cs.backgroundColor || "").replace(/\s/g, "");

      // rojos típicos: rgb(255,0,0) / rgb(239,68,68) / similares
      const isRed =
        bg.startsWith("rgb(255,0,0)") ||
        bg.startsWith("rgba(255,0,0") ||
        bg.includes("rgb(239,68,68)") ||
        bg.includes("rgb(220,38,38)");

      if (!isRed) return;

      // Si el elemento es grande tipo botón (altura/anchura)
      const r = el.getBoundingClientRect();
      if (r.height >= 40 && r.width >= 200) {
        el.style.display = "none";
      }
    });
  }

  function init() {
    hideCODButtons();

    // EasySell suele inyectar tarde => observador
    const obs = new MutationObserver(() => hideCODButtons());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
